import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { Query } from './Query';

const CLIENT_CODE_QUERY_ID = 'clientCode';

export class FundListsQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const response: string[] = [];
		const context = Query.getContext(executionOptions, this.options);
		const { fundListMapping } = context || {};
		if (fundListMapping) {
			const { subQueries } = this.options;
			const clientCodeSubQuery = (subQueries || []).find(subQuery => subQuery.queryId === CLIENT_CODE_QUERY_ID);
			if (clientCodeSubQuery) {
				const clientCodeQuery = new Query(clientCodeSubQuery);
				const clientCode = clientCodeQuery.execute(executionOptions);
				if (clientCode) {
					for (const fundListName of Object.keys(fundListMapping)) {
						const fundListMap = fundListMapping[fundListName];
						if (fundListMap[clientCode]) {
							response.push(fundListName);
						}
					}
				}
			}
		}
		return response as any;
	}
}